import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : '';
const portalApiBaseURL = typeof window !== 'undefined' ? window.serverData.data.portalAPIURL : '';

export const getFAQ = () => {
    const url = window.serverData.data.faqApiUrl;
    var start = new Date();
    return fetch(url).then(response => {
        logAPI("MBHWeb.Api.FAQ.GetFAQ", start, url);
        return Promise.resolve(response.text());
    }).catch(err => {
        logAPI("MBHWeb.Api.FAQ.GetFAQ.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const getPrivacyHealthPlanData = (payload) => {
    return getPolicyText(payload.featureId, payload.token);
};

export const getPrivacyMyBswhData = (payload) => {
    return getPolicyText(payload.featureId, payload.token);
};

export const getPrivacyMyChartData = (payload) => {
    return getPolicyText(payload.featureId, payload.token);
};

export const getPolicyText = (featureId, token) => {
    if (featureId === undefined || featureId == "undefined") {
        return "";
    }
    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }
    var oBody = {};
    oBody["FeatureId"] = featureId;
    oBody["UserToken"] = token;
    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };

    var url = `${portalApiBaseURL}/GetPrivacyPolicy`;
    var params = {
        method: "POST",
        body: JSON.stringify(oBody),
        headers: oHeaders,
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.GetPrivacyInformation", start, url);
        if (response.ok) {
           return Promise.resolve(response.json());
        }
        else{
           return Promise.reject(response);
        }
    }).catch(e => {
        logAPI("MBHWeb.Api.GetPrivacyInformation", start, url, e);
        return Promise.reject(e);
    }
    );
};

export const getMyCharDocsData = (docid, localization) => {

    const url = tools.buildUrl(`/Api/Docs/GetMyCharDocsData/${docid}/${localization}`);
    return getData(url);
};

const getData = (url) => {
    const params = {
        method: "GET",
        headers: {
            "Accept": "text/html"
        }
    };

    //const request = new Request(url, params);
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.MyChart.GetMyChartDocsData", start, url); //i am not considering it as web_api, but still considering for logging.
        return Promise.resolve(response.text());
    }).catch(err => {
        //debugger;
        console.log(err);
        logAPI("MBHWeb.Api.MyChart.GetMyChartDocsData.Failure", start, url, err);
        return Promise.reject(err);
    });
};